<p-dialog
  #fastCentroResultado
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar centro de resultado</span>
      <i class="pi pi-fw pi-money-bill ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row m-0 pt-2">
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input
          matInput
          type="text"
          [formControl]="form.get('descricao')"
          (blur)="actionFnCheckEntityExist(form.get('descricao'))"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('duplicate')
        "
      >
        Já existe um centro de resultado com essa descrição!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('required')
        "
      >
        A descrição é obrigatória
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('maxlength')
        "
      >
        A descrição deve conter até 255 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('isEmptyValue')
        "
      >
        Inválido: remova os espaços em branco!
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <fast-autocomplete
        #input
        [autoFirst]="false"
        id="field-centro-resultado"
        placeholder="Centro de resultados"
        displayField="descricao"
        [value_order]="'descricao'"
        [domain_id]="tokenService.getDomain().id"
        (clearSelection)="form.get('centro_resultado').reset()"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [control]="form.get('centro_resultado')"
        [entityService]="entityService"
        [actionState]="false"
        [initDataWithEmpty]="true"
        [messages]="{
          typeIs: 'Valor inválido',
          isEmptyValue: 'Valor inválido: remova os espaços em branco'
        }"
      ></fast-autocomplete>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!form.valid || loading"
      ></button>
    </div>
  </ng-template>
</p-dialog>
